<template>
    <div style="padding-top:50px">
        <h3>Sorry, permission denied.</h3>
         <i class="material-icons" style="font-size:50px">sentiment_very_dissatisfied</i>
    </div>
</template>

<script>
export default {
    name:"PermissionDenied"
}
</script>


// WEBPACK FOOTER //
// src/components/PermissionDenied.vue